export const keycloakConfig = {
  useKeycloak: process.env.VUE_APP_USE_KEYCLOAK === "true",
  url: process.env.VUE_APP_KEYCLOAK_URL || "http://localhost:8085",
  realm: process.env.VUE_APP_KEYCLOAK_REALM || "probono",
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "probono-solutionfinder-app",
  onLoad: "login-required",
};
